import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./apiClient";
import { useSelector } from "react-redux";
import userSelector from "@/store/selectors/userSelector";
import { useGetActiveMunicipality } from "./getMunicipality";

export const useGetBuildingGroups = () => {
  const user = useSelector(userSelector);
  const municipalityId = useGetActiveMunicipality();

  // Keep dashboard/sidebar on a single grouped payload to avoid per-group request fan-out.
  return useQuery({
    queryKey: ['building-groups', municipalityId, user?.session_id],
    queryFn: async () => {
      const res = await apiClient.get('/building-groups', {
        params: { municipalityId: municipalityId as string }
      });
      return res.data.payload ?? [];
    },
    enabled: !!municipalityId && !!user?.verifiedEmail && !!user?.verifiedByAdmin
  });
}